var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompareLevelsCheckWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "close",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.874,
    height: 28.879,
    viewBox: "0 0 28.874 28.879",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13047",
    "data-name": "Group 13047",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000026123480862262695870000014710365773972803006_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close-2",
    "data-name": "close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5788",
    "data-name": "Path 5788",
    d: "M14.432,28.9A14.441,14.441,0,0,1,4.226,4.252l.6.6-.6-.6A14.44,14.44,0,1,1,14.432,28.9Zm0-27.188a12.748,12.748,0,1,0,9.012,3.734,12.746,12.746,0,0,0-9.012-3.734Z",
    transform: "translate(0 -0.022)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g443",
    transform: "translate(7.724 9.522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path445",
    d: "M-286-16.843a1.125,1.125,0,0,1-.8-.33l-3.6-3.6a1.128,1.128,0,0,1,0-1.6,1.128,1.128,0,0,1,1.6,0l2.805,2.8,6.77-6.77a1.128,1.128,0,0,1,1.6,0,1.128,1.128,0,0,1,0,1.6l-7.568,7.568A1.125,1.125,0,0,1-286-16.843Z",
    transform: "translate(290.729 26.667)",
    fill: "#ffffff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareLevelsCheckWhite);
export default __webpack_public_path__ + "static/media/compare_levels_check_white.91eeb97a9286eb7108b7d3bd8b8056c1.svg";
export { ForwardRef as ReactComponent };